import { render, staticRenderFns } from "./ClockPopupView.vue?vue&type=template&id=1ba0e05b&scoped=true&"
import script from "./ClockPopupView.vue?vue&type=script&lang=js&"
export * from "./ClockPopupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba0e05b",
  null
  
)

export default component.exports